(() => {
  'use strict';
  document.querySelectorAll('[data-metaobject-export]').forEach(panel => {
    if (panel.dataset.initialized) return;
    panel.dataset.initialized = 'true';
    const el = name => panel.querySelector(`[data-export-${name}]`);
    const select = el('type');
    const download = el('download');
    const status = el('status');
    let selectedInfo = null;
    let revision = 0;
    let pending = null;
    const message = (text, error = false) => {
      status.textContent = text;
      status.dataset.error = String(error);
    };
    function clearInfo() { selectedInfo = null; el('info').hidden = true; download.disabled = true; }
    function cancel() { revision++; pending?.abort(); pending = null; }
    function reset() {
      cancel(); clearInfo();
      select.replaceChildren(new Option('목록을 먼저 불러오세요', ''));
      select.disabled = true; el('load').disabled = false;
      message('선택을 초기화했습니다. 목록을 다시 불러오세요.');
    }
    async function request(path, signal) {
      const response = await fetch(panel.dataset.apiBase + path, {
        method: 'GET',
        signal, cache: 'no-store', credentials: 'omit'
      });
      if (!response.ok) {
        let text = '요청에 실패했습니다. 잠시 후 다시 시도해주세요.';
        try { text = (await response.json()).message || text; } catch (_) { /* Not a JSON error. */ }
        throw new Error(text);
      }
      return response;
    }
    el('reset').addEventListener('click', reset);
    window.addEventListener('pagehide', reset);
    el('load').addEventListener('click', async () => {
      cancel(); clearInfo();
      select.disabled = true; select.replaceChildren(new Option('목록 조회 중…', ''));
      el('load').disabled = true;
      const current = revision;
      pending = new AbortController();
      message('메타객체 목록을 불러오는 중입니다.');
      try {
        const body = await (await request('/types', pending.signal)).json();
        if (current !== revision) return;
        if (!Array.isArray(body.types)) throw new Error('목록 응답이 올바르지 않습니다.');
        select.replaceChildren(new Option('메타객체를 선택하세요', ''));
        body.types.forEach(item => select.add(new Option(item.name, item.type)));
        select.disabled = body.types.length === 0;
        message(body.types.length ? `${body.types.length}개의 메타객체를 조회했습니다.` : '다운로드 가능한 메타객체가 없습니다.');
      } catch (error) {
        if (current === revision && error.name !== 'AbortError') message(error.message, true);
      } finally { if (current === revision) el('load').disabled = false; }
    });
    select.addEventListener('change', async () => {
      cancel(); clearInfo();
      if (!select.value) { message('메타객체를 선택해주세요.'); return; }
      const current = revision;
      pending = new AbortController();
      message('선택한 메타객체 정보를 조회하는 중입니다.');
      try {
        const info = await (await request('/info?type=' + encodeURIComponent(select.value), pending.signal)).json();
        if (current !== revision) return;
        if (info.type !== select.value || !Array.isArray(info.fields) || !Number.isInteger(info.count)) throw new Error('정보 응답이 올바르지 않습니다.');
        selectedInfo = info;
        el('name').textContent = info.name;
        el('type-label').textContent = info.type;
        el('count').textContent = `${info.count.toLocaleString()}건`;
        el('field-count').textContent = `${info.fields.length}개`;
        el('fields').replaceChildren(...info.fields.map(field => {
          const item = document.createElement('li'); item.textContent = `${field.name} (${field.key}) · ${field.type}`; return item;
        }));
        el('info').hidden = false;
        download.disabled = info.count > 10000;
        message(info.count > 10000 ? '10,000건을 초과하여 별도 내보내기가 필요합니다.' : '정보 조회 완료. CSV 다운로드를 누르세요.');
      } catch (error) {
        if (current === revision && error.name !== 'AbortError') message(error.message, true);
      }
    });
    download.addEventListener('click', async () => {
      if (!selectedInfo) return;
      const info = selectedInfo;
      cancel(); const current = revision;
      pending = new AbortController();
      download.disabled = true; select.disabled = true; el('load').disabled = true;
      message('전체 엔트리를 조회하고 CSV를 생성하는 중입니다. 잠시 기다려주세요.');
      try {
        const response = await request('/csv?type=' + encodeURIComponent(info.type), pending.signal);
        if (!(response.headers.get('content-type') || '').includes('text/csv')) throw new Error('CSV 파일 응답이 아닙니다.');
        const blob = await response.blob();
        if (current !== revision) return;
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${info.type}_${new Date().toISOString().replace(/[:.]/g, '-')}.csv`;
        document.body.append(link); link.click(); link.remove();
        setTimeout(() => URL.revokeObjectURL(url), 1000);
        const count = response.headers.get('X-Export-Count') || info.count;
        const unresolved = Number(response.headers.get('X-Export-Unresolved-References') || 0);
        message(`${count}건 CSV 다운로드가 준비되었습니다.` + (unresolved ? ` 참조 ${unresolved}개의 추가 정보를 조회하지 못해 원본 GID만 포함했습니다.` : ''));
      } catch (error) {
        if (current === revision && error.name !== 'AbortError') message(error.message, true);
      } finally {
        if (current === revision) { download.disabled = !selectedInfo; select.disabled = false; el('load').disabled = false; }
      }
    });
  });
})();
